import Cookies from 'js-cookie'
import type { Router } from 'vue-router'
import type { CommissionJunctionInput } from '@/graphql/api'

export function setCommissionJunctionEvent(router: Router): void {
    const cjevent = router.currentRoute.value?.query?.['cjevent']

    if (cjevent && typeof cjevent === 'string') {
        Cookies.set('cjevent', cjevent, { expires: 90 })
    }
}

export function getCommissionJunctionEvent(): string | undefined {
    return Cookies.get('cjevent')
}

export function getCommissionJunctionInput():
    | CommissionJunctionInput
    | undefined {
    const commissionJunctionCode = getCommissionJunctionEvent()

    return commissionJunctionCode ? { code: commissionJunctionCode } : undefined
}
